export default __webpack_public_path__ + "e9c4f0f62cfc30d26d84d8497a5c11bd.png";